import React from 'react';
import { connect } from 'react-redux';
import { selectFitUnreadFeatures } from '../../store/slice';
import { RootState } from '../../../../app/store';
import styled from 'styled-components';
import { inkwell } from '../../../../colors';
import {
  Text,
  Divider as StormDivider,
  TextButton,
  Tag as StormTag,
} from '@amzn/storm-ui';
import { shouldLoadSystemJsAssets } from 'src/commons/utils';

/* eslint-disable-next-line */
declare var System: any;

const FeatureCenterButton = styled(TextButton)`
  padding: ${({ theme }) => theme.spacing.small};
  text-decoration: none;
  color: ${inkwell};
  width: 100%;
  text-align: left;
  display: flex;

  &:hover {
    background-color: rgba(111, 111, 111, 0.1);
    text-decoration: none;
    color: ${inkwell};
  }
`;

const Divider = styled(StormDivider)`
  margin: ${({ theme }) => theme.spacing.mini} -${({ theme }) => theme.spacing.base};
`;

const Tag = styled(StormTag)`
  margin-left: ${({ theme }) => theme.spacing.mini};
  align-self: flex-end;
  background: rgb(1, 132, 133);
`;

const WhatsNewIcon: React.VFC<{
  fitUnreadFeatures: number;
  featureCenterLabel: string;
}> = ({ fitUnreadFeatures, featureCenterLabel }) => {
  return featureCenterLabel ? (
    <>
      <Divider />
      <FeatureCenterButton
        data-ccx-e2e-id="aac-fit-feature-center-button"
        data-takt-id="aac-help-menu-item-feature-center"
        onClick={() => {
          if (shouldLoadSystemJsAssets()) {
            window.System.import('@amzn/intro-widgets-api').then((module) =>
              module.default.openNewFeatureCenter(),
            );
          } else {
            import('@amzn/intro-widgets-api').then((module) =>
              module.openNewFeatureCenter(),
            );
          }
        }}
      >
        <Text>{featureCenterLabel}</Text>
        {fitUnreadFeatures > 0 && (
          <Tag
            type="new"
            label={fitUnreadFeatures}
            description={fitUnreadFeatures.toString()}
          />
        )}
      </FeatureCenterButton>
    </>
  ) : null;
};

const mapStateToProps = (state: RootState) => {
  return {
    fitUnreadFeatures: selectFitUnreadFeatures(state),
  };
};

export default connect(mapStateToProps)(WhatsNewIcon);
